import { buildGraphqlQuery, buildUserSearchFilter } from '@ztechapps/common.utils'

//region GraphQL query
const queries = buildGraphqlQuery(
  'Vendor',
  `_id
      profile {
        _id
        name
        email
        picture
      }
      status
      company {
        _id
        name
        domain
      }`
)

//endregion

export const useVendorSelect = () => {
  const dataLoadOptions = ({ filter }: any) => ({
    query: queries?.allConfig?.query,
    filter: ({ input }: any) => ({
      ...buildUserSearchFilter(input),
      ...filter,
    }),
    options: () => ({
      sort: { 'company.name': 1 as const },
    }),
    resultFieldName: 'allVendor',
  })

  return { dataLoadOptions }
}
